import { useState, useCallback } from 'react'
import { ICarrier } from 'apps/fleet-planner/types'
import { fetchAllCarriers } from 'apps/fleet-planner/utils/api/carriers'

interface IUseCarrier {
  getCarriers: () => void
  carriers: ICarrier[]
  errors?: string
  isCarrierListLoading: boolean
}
/**
 * Hook used to manage getCarrier
 */
export const useCarrierApi = (): IUseCarrier => {
  const [carriers, setCarriers] = useState<ICarrier[]>([])
  const [errors, setErrors] = useState<string | undefined>()
  const [isCarrierListLoading, setIsCarrierListLoading] = useState<boolean>(false)

  const getCarriers = useCallback(async (): Promise<void> => {
    setErrors(undefined)
    setIsCarrierListLoading(true)
    try {
      const { motorCarriers: response } = await fetchAllCarriers()
      setCarriers(response)
    } catch (e) {
      setErrors(e)
    }
    setIsCarrierListLoading(false)
  }, [])

  return {
    getCarriers,
    carriers,
    errors,
    isCarrierListLoading,
  }
}
